/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delivery': {
    width: 41,
    height: 28,
    viewBox: '0 0 41 28',
    data: '<path pid="0" class="st0" d="M38.3 23.3h-1.7v-2h1.7c.4 0 .7-.3.7-.7v-5.8c0-.9-.5-.9-.7-.9h-1.4l-3.2-5.7c-.1-.1-.3-.2-.6-.2h-6.8V6h6.8c.9 0 1.7.4 2.2 1.2L38 12h.3c1.6 0 2.7 1.2 2.7 2.9v5.8c0 1.4-1.2 2.6-2.7 2.6z"/><path pid="1" class="st0" d="M27.4 23.3H13.6v-2h11.8V2H11.9V0h15.5z"/><path pid="2" class="st0" d="M33.2 27.5c-2.4 0-4.3-1.9-4.4-4.3h-2.4v-2h2.8c.7-1.5 2.2-2.5 4-2.5 2.4 0 4.4 2 4.4 4.4s-2 4.4-4.4 4.4zm0-6.8c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4 2.4-1.1 2.4-2.4-1.1-2.4-2.4-2.4zm-23 6.8c-2.4 0-4.3-1.9-4.4-4.3H2.6v-2h3.7c.7-1.5 2.2-2.5 4-2.5 2.4 0 4.4 2 4.4 4.4s-2 4.4-4.5 4.4zm0-6.8c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4c1.3 0 2.4-1.1 2.4-2.4s-1.1-2.4-2.4-2.4zM35 14.8h-6.9v-2h4.6l-1.2-1.9 1.7-1.1 1.8 2.8zM14.5 12.2H0v-2h14.5v2zm5.1-5.1H6.8v-2h12.8v2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/delivery.js